import { axiosClient } from '../axios';
import { classifyErrorCategory, classifyOtherError } from './errorCategories';
import { parseAxiosRequestData } from './supportFeatureTitles';
import { startEventFlushScheduler, trackApiResponseError, trackEvent } from './trackEvent';

const MONITORING_FLAG = '__footprintsMonitoringInstalled';

function trackAxiosFailure(error) {
    const config = error?.config;
    const endpoint = config?.url;
    const data = error?.response?.data;

    if (data?.status === 'error') {
        if (!endpoint) return;
        trackApiResponseError(data, {
            endpoint,
            method: config?.method,
            requestData: parseAxiosRequestData(config),
        });
        return;
    }

    const message = data?.error || data?.message || error?.message;
    if (!message) return;

    const category = (endpoint && classifyErrorCategory(endpoint))
        || classifyOtherError(message, error);
    if (!category) return;

    trackEvent({
        category,
        endpoint,
        method: config?.method,
        message,
        requestData: parseAxiosRequestData(config),
    });
}

function safeTrack(fn) {
    try {
        fn();
    } catch (e) {
        console.warn('[monitoring] track failed:', e?.message);
    }
}

export function setupAxiosMonitoring() {
    // Persist on axiosClient — module-level `installed` resets on hot reload and stacks interceptors.
    if (axiosClient[MONITORING_FLAG]) return;
    axiosClient[MONITORING_FLAG] = true;

    startEventFlushScheduler();

    axiosClient.interceptors.response.use(
        (response) => {
            safeTrack(() => {
                trackApiResponseError(response?.data, {
                    endpoint: response?.config?.url,
                    method: response?.config?.method,
                    requestData: parseAxiosRequestData(response?.config),
                });
            });
            return response;
        },
        (error) => {
            safeTrack(() => trackAxiosFailure(error));
            return Promise.reject(error);
        }
    );
}
